import { render } from "./LeapSecondsForm.vue?vue&type=template&id=7653ea21&scoped=true"
import script from "./LeapSecondsForm.vue?vue&type=script&lang=js"
export * from "./LeapSecondsForm.vue?vue&type=script&lang=js"

import "./LeapSecondsForm.vue?vue&type=style&index=0&id=7653ea21&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7653ea21"]])

export default __exports__